import React from "react";
import HighlightedText from "../../../../components/HighlightKeyword";

export default function UMATable({
  documentList,
  openModal,
  query,
  handleSortDocument,
  handleSortTitle,
  getArrowIcon,
}) {
  const renderEgDocumentTitles = (egTitle) => {
    const mainTitleBM = egTitle.egDocumentDto.actTitleBM;
    const mainTitleBI = egTitle.egDocumentDto.actTitleBI;
    const titles = egTitle.egDocumentDto.titles;
    return (
      <>
        {mainTitleBI && (
          <HighlightedText paragraph={mainTitleBI} keyword={query} />
        )}
        {titles !== undefined &&
          titles !== null &&
          titles.length > 0 &&
          titles.map((title) =>
            title.titleBI ? (
              <div key={title.egTitleId} className="egTitle-title">
                <p>{title.no}</p>
                <HighlightedText paragraph={title.titleBI} keyword={query} />
                <br />
              </div>
            ) : null
          )}
        {mainTitleBM && (
          <HighlightedText paragraph={mainTitleBM} keyword={query} />
        )}

        {titles !== undefined &&
          titles !== null &&
          titles.length > 0 &&
          titles.map((title) =>
            !title.titleBI && title.titleBM ? (
              <div key={title.egTitleId} className="egTitle-title">
                <p>{title.no}</p>
                <HighlightedText paragraph={title.titleBM} keyword={query} />
                <br />
              </div>
            ) : null
          )}
      </>
    );
  };

  return (
    <table className="case-law-table">
      <thead>
        <tr>
          <th
            style={{ width: "10%" }}
            onClick={() => handleSortDocument("tamb")}
          >
            <div className="case-law-table-header">
              UMA {getArrowIcon("tamb")}
            </div>
          </th>
          <th
            style={{ minWidth: "20vw" }}
            onClick={() => handleSortTitle("titleBI")}
          >
            <div className="case-law-table-header">
              Title {getArrowIcon("titleBI")}
            </div>
          </th>
          <th
            style={{ width: "20%" }}
            onClick={() => handleSortDocument("publicationDate")}
          >
            <div className="case-law-table-header">
              Publication {getArrowIcon("publicationDate")}
            </div>
          </th>
        </tr>
      </thead>
      <tbody>
        {documentList.map((item) => (
          <tr key={item.egDocumentDto.documentId}>
            <td style={{ verticalAlign: "middle", textAlign: "center" }}>
              {item?.egDocumentDto.tamb}
            </td>
            <td onClick={() => openModal(item?.documentBlobDto?.fileUUID, 1)}>
              {renderEgDocumentTitles(item)}
            </td>
            <td style={{ textAlign: "center" }}>
              {new Date(
                item?.egDocumentDto?.publicationDate
              ).toLocaleDateString("en-GB", {
                day: "2-digit",
                month: "2-digit",
                year: "numeric",
              })}
              {/* {item?.egDocumentDto.publicationDate} */}
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}
